import { Injectable } from '@angular/core';
import { kosRegistry, DocId } from '@octiga/kos-registry/generated';
import { environment } from '../../environments/environment';

/**
 * In-app documentation links, resolved through the generated doc registry
 * (@octiga/kos-registry — "Kos" is the internal codename for the docs platform,
 * the public site/URLs are unaffected) — application code references stable
 * doc IDs, never URLs, so reorganising the docs site cannot silently break
 * help links: a removed ID is a compile error.
 */
@Injectable({ providedIn: 'root' })
export class HelpService {
    /** Absolute URL of a docs page (optionally deep-linked to a section anchor). */
    docsUrl(docId: DocId, sectionKey?: string): string {
        const entry = kosRegistry[docId];
        const sections: Record<string, string> = entry.sections;
        const anchor = sectionKey && sections[sectionKey] ? `#${sections[sectionKey]}` : '';
        return `${environment.docsBaseUrl}${entry.url}${anchor}`;
    }

    /** Open a docs page in a new tab. */
    showHelp(docId: DocId, sectionKey?: string): void {
        window.open(this.docsUrl(docId, sectionKey), '_blank', 'noopener');
    }
}
